import React from "react";
import styled from "@emotion/styled";
import PropTypes from "prop-types";

// style rules
import { Typography, Colors } from "../../styles";

const SelectedFilters = ({selectedFilters, clearAllFilters, handleFilterSelect}) => {
	return (
		<Container className="selectedFilters">
			<FlexRow>
				{selectedFilters.map((taxonomyObj) => {
					return taxonomyObj.filters.map((filter) => {
						return (
							<Selected
								dangerouslySetInnerHTML={{
									__html: filter.title + " x",
								}}
								onClick={() =>
									handleFilterSelect({
										taxonomy: taxonomyObj.taxonomy,
										filters: [filter],
									})
								}
								key={filter.slug}
							/>
						);
					});
				})}
			</FlexRow>
			<div>
				<ClearFiltersButton onClick={clearAllFilters}>
					Clear Filters
				</ClearFiltersButton>
			</div>
		</Container>
	);
};

SelectedFilters.propTypes = {
	selectedFilters: PropTypes.array,
	clearAllFilters: PropTypes.func,
	handleFilterSelect: PropTypes.func
};

export default SelectedFilters;

const Container = styled.div`
	display: flex;
	gap: 0.9rem;
	justify-content: space-between;
	align-items: center;
	padding-top: 4rem;
	padding-bottom: 2.3rem;
`;

const FlexRow = styled.div`
	display: flex;
	gap: 0.9rem;
`;

const Selected = styled.button`
	background: rgba(31, 31, 31, 0.9);
	border-radius: 0;
	padding: 0.3rem 0.7rem;
	height: fit-content;
	color: ${Colors.base.white};

	font-weight: ${Typography.fontWeight.black};
	font-size: 1.4rem;
	line-height: 2.2rem;
	letter-spacing: -0.001em;
	text-transform: uppercase;

	span {
		font-weight: ${Typography.fontWeight.regular};
	}
`;

const ClearFiltersButton = styled.button`
	position: relative;
	z-index: 2;
	border-radius: 10px;
	border: 0;
	color: ${Colors.base.black};
	display: inline-block;
	font-weight: ${Typography.fontWeight.demiBold};
	font-family: ${Typography.fontFamily.base};
	text-decoration: none;
	text-align: center;
	font-size: 1.4rem;
	line-height: 1.7rem;
	text-transform: uppercase;
	padding: 1.9rem 3.7rem;
	transition: ease-out 0.7s;
	cursor: pointer;
	background-color: ${Colors.goldenSun.base};
	letter-spacing: normal;
	white-space: nowrap;

	&:hover,
	&:focus {
		background-color: ${Colors.riverBlue};
	}
	span {
		font-weight: ${Typography.fontWeight.regular};
	}
`;
